// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  reportId: __t.u64().primaryKey().name("report_id"),
  reporter: __t.identity(),
  target: __t.identity(),
  category: __t.string(),
  detail: __t.string(),
  refKind: __t.string().name("ref_kind"),
  refId: __t.u64().name("ref_id"),
  state: __t.string(),
  at: __t.timestamp(),
});
